import React, { useEffect, useMemo, useRef, useState } from 'react'
import { DateRangePicker } from "rsuite";
import '../AnalyticsDashboard.css';
import axios from 'axios';
import Cookies from 'js-cookie';
import {showToast as toast} from '../toastManager';
import Spinner from 'react-bootstrap/Spinner';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Badge from 'react-bootstrap/Badge';
import Label from 'react-bootstrap/FormLabel';
import FormSelect from 'react-bootstrap/FormSelect';
import Modal from 'react-bootstrap/Modal';
import ReMultiSelect, { components as ReSelectComponents } from 'react-select';
import ReMultiSelectAnimated from 'react-select/animated';
import errorMessages from '../errorMessages.js';

// Custom option component with checkbox for multi-select filters
const CheckboxOption = (props) => {
    return (
        <ReSelectComponents.Option {...props}>
            <input
                type="checkbox"
                checked={props.isSelected}
                readOnly
                style={{ marginRight: 8 }}
            />
            <label style={{ margin: 0 }}>{props.label}</label>
        </ReSelectComponents.Option>
    );
};

function AnalyticsDashboard({ViewedPage, shop_domain, app_url}) {
    ViewedPage(36)
    
    const { combine, before, afterToday } = DateRangePicker;
    const max_date = new Date();
    max_date.setDate(max_date.getDate() - 365);

    // Default time period: last 1 month
    const initialEndDate = new Date();
    const initialStartDate = new Date();
    initialStartDate.setMonth(initialStartDate.getMonth() - 1);

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [show_filters, setShowfilters] = useState(false);
    const [analyticsData, setAnalyticsData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [filterOptions, setFilterOptions]= useState({});
    
    // Filter states
    const [selected_date_range_value, setDateRange] = useState([initialStartDate, initialEndDate]);
    const [filter_unique_value_dict, setFilterUniqueValueDict] = useState({
        "landing_page": [],
        "device": [],
        "sxi_content": [],
        "utm_source": [],
        "utm_medium": [],
        "utm_campaign": [],
        "utm_content": [],
        "utm_term": [],
        "conversion": [],
        "section_category": [],
        "section_sub_category": []
    });
    const [selected_filter_unique_value_dict, setSelectedFilterUniqueValueDict] = useState({
        "landing_page": {"filter_val": []},
        "device": {"filter_val": []},
        "sxi_content": {"filter_val": []},
        "utm_source": {"filter_val": []},
        "utm_medium": {"filter_val": []},
        "utm_campaign": {"filter_val": []},
        "utm_content": {"filter_val": []},
        "utm_term": {"filter_val": []},
        "conversion": {"filter_val": []},
        "section_category": {"filter_val": []},
        "section_sub_category": {"filter_val": []}
    });
    // Snapshot of advanced filters when modal opens; restored on cancel (Close/backdrop)
    const filtersSnapshotRef = useRef(null);
    const submitClickedRef = useRef(false);

    useEffect(() => {
        setLoading(true);
        try {
            if(Cookies.get('shop')){
                // Fetch data for default time period (last 1 month) on initial load
                const created_at_min = new Date(selected_date_range_value[0]);
                const created_at_max = new Date(selected_date_range_value[1]);
                fetchAnalyticsData({ created_at_min, created_at_max });
                getFiltersData(Cookies.get('shop'));
            }
        }
        catch(err){
            toast.error(`${errorMessages["DATA_LOAD_ERROR"]["title"]}`);
            console.log(err)
        }
        finally {
            setLoading(false);
        }
    }, [app_url, shop_domain]);

    // Debug: Monitor filter options changes
    useEffect(() => {
        console.log('filter_unique_value_dict changed:', filter_unique_value_dict);
    }, [filter_unique_value_dict]);
    const getFiltersData=async (shopName, landingPage = null)=>{
        const opts = {
            landingPages: [],
            devices: [],
            httpRefers:[],
            sxiContents: [],
            sxiIds: [],
            sxiLocations: []
        };

        try{
            // Fetch dynamic filter options based on landing page
            const response = await axios.post(`${app_url}/api/analytics-dashboard/get_dynamic_filter_options`,{
                shop_domain: shopName,
                landing_page: landingPage
            });
            
            if (response.data.success) {
                let data = response.data.data;
                console.log('Dynamic filter options:', data);
                
                // Ensure all arrays are properly formatted for React Select
                // IMPORTANT: Landing page options come from MongoDB via fetchAnalyticsData.
                // Do NOT override them with BigQuery filter responses (which may be scoped to one landing page).
                const landingPageOpts = filter_unique_value_dict["landing_page"] || [];
                let options = {
                    device: Array.isArray(data.devices) ? data.devices.map(x=>({value:x,label:x})) : [],
                    sxi_content: Array.isArray(data.sxiContents) ? data.sxiContents.map(x=>({value:x,label:x})) : [],
                    utm_source: Array.isArray(data.utmSources) ? data.utmSources.map(x=>({value:x,label:x})) : [],
                    utm_medium: Array.isArray(data.utmMediums) ? data.utmMediums.map(x=>({value:x,label:x})) : [],
                    utm_campaign: Array.isArray(data.utmCampaigns) ? data.utmCampaigns.map(x=>({value:x,label:x})) : [],
                    utm_content: Array.isArray(data.utmContents) ? data.utmContents.map(x=>({value:x,label:x})) : [],
                    utm_term: Array.isArray(data.utmTerms) ? data.utmTerms.map(x=>({value:x,label:x})) : [],
                    conversion: Array.isArray(data.conversions) ? data.conversions.map(x=>({value:String(x),label:String(x)})) : [],
                    landing_page: landingPageOpts,
                    section_category: Array.isArray(data.sectionCategories) ? data.sectionCategories.map(x=>({value:String(x),label:String(x)})) : [],
                    section_sub_category: Array.isArray(data.sectionSubCategories) ? data.sectionSubCategories.map(x=>({value:String(x),label:String(x)})) : []
                };
                
                console.log('Formatted options for React Select:', options);
                console.log('Setting filter_unique_value_dict with:', options);
                // Single state update so options are not lost due to batched updates
                setFilterUniqueValueDict(options);
                setFilterOptions(data);
            }
        }catch (error) {
            console.error('Error fetching dynamic filter option data:', error);
            setError('Error fetching dynamic filter option data');
            toast.error('Error fetching dynamic filter option data');
            setFilterOptions(opts);
        } 
    }
//device="", sxi_id="",sxi_content="",sxi_location_id=""
    const fetchAnalyticsData = async (fltrs={}) => {
        try {
            setLoading(true);
            setError(null);
            console.info('shop domain',Cookies.get('shop'));
            
            // Clear Redis cache first to ensure fresh data
            try {
                await axios.post(`${app_url}/api/analytics-dashboard/clear_cache`, {
                    shop_domain: Cookies.get('shop')
                }, {withCredentials: true});
                console.log('Cache cleared before fetching analytics data');
            } catch (cacheError) {
                console.warn('Failed to clear cache:', cacheError);
                // Continue with data fetch even if cache clear fails
            }
            
            // Prepare filters object
            let filters = {
                device: "",
                sxi_content: "",
                utm_source: "",
                utm_medium: "",
                utm_campaign: "",
                utm_content: "",
                utm_term: "",
                conversion: "",
                landing_page: "",
                section_category: "",
                section_sub_category: "",
                created_at_max: "",
                created_at_min: ""
            };
            filters = { ...filters, ...fltrs };
            
            const { created_at_min, created_at_max } = filters;
            
            // Only add date filters if dates are provided
            if (created_at_min && created_at_max) {
                filters.date_start = formatDate(created_at_min);
                filters.date_end = formatDate(created_at_max);
            }
            
            // Fetch section analytics data (MongoDB + BigQuery combined)
            const response = await axios.post(`${app_url}/api/analytics-dashboard/get_section_analytics`, {
                shop_domain: Cookies.get('shop'),
                filters: filters
            }, {withCredentials: true});
            
            if (response.data.success) {
                setAnalyticsData(response.data.data);
                // Only set date range if dates were provided
                if (created_at_min && created_at_max) {
                    setDateRange([created_at_min, created_at_max]);
                }
                console.log(response.data.data);
                // Update landing page URLs but preserve other filter options.
                // Use functional setState to avoid overwriting newer filter options
                // populated by getFiltersData due to stale closures / race conditions.
                if (response.data.landingPageUrls && response.data.landingPageUrls.length > 0) {
                    const landingPageOptions = response.data.landingPageUrls.map(url => ({
                        value: url,
                        label: url
                    }));
                    console.log('Landing page URLs from MongoDB:', response.data.landingPageUrls);
                    console.log('Updated landing_page options:', landingPageOptions);
                    setFilterUniqueValueDict(prev => ({
                        ...prev,
                        landing_page: landingPageOptions
                    }));
                    // On initial load (no landing page filter), default to first landing page
                    if (!filters.landing_page || String(filters.landing_page).trim() === '') {
                        const firstUrl = response.data.landingPageUrls[0];
                        const defaultFilterDict = {
                            "landing_page": { "filter_val": [firstUrl] },
                            "device": { "filter_val": [] },
                            "sxi_content": { "filter_val": [] },
                            "utm_source": { "filter_val": [] },
                            "utm_medium": { "filter_val": [] },
                            "utm_campaign": { "filter_val": [] },
                            "utm_content": { "filter_val": [] },
                            "utm_term": { "filter_val": [] },
                            "conversion": { "filter_val": [] },
                            "section_category": { "filter_val": [] },
                            "section_sub_category": { "filter_val": [] }
                        };
                        setSelectedFilterUniqueValueDict(defaultFilterDict);
                        try {
                            await getFiltersData(Cookies.get('shop'), firstUrl);
                            await fetchAnalyticsData({
                                landing_page: firstUrl,
                                created_at_min: filters.created_at_min,
                                created_at_max: filters.created_at_max
                            });
                        } catch (err) {
                            console.warn('Default landing page setup failed:', err);
                        }
                        // Filtered data already set by the fetchAnalyticsData call above
                    } else {
                        setFilteredData(response.data.data);
                    }
                } else {
                    console.log('No landing page URLs found in response');
                    setFilteredData(response.data.data);
                }
            } else {
                setError('Failed to fetch analytics data');
                toast.error('Failed to fetch analytics data');
            }
        } catch (error) {
            console.error('Error fetching analytics data:', error);
            setError('Error fetching analytics data');
            toast.error('Error fetching analytics data');
        } finally {
            setLoading(false);
        }
    };

    const handleDateChange = (date_range) => {
        if((date_range !== undefined) && (date_range !== null) && (date_range.length > 0)){
            // Validate that we have valid Date objects - only update state; fetch on Apply
            if (date_range[0] instanceof Date && date_range[1] instanceof Date) {
                setDateRange(date_range);
            } else {
                console.error('Invalid date range provided:', date_range);
                toast.error('Invalid date range selected');
            }
        }
    };

    const handle_filters_hide = () => {
        if (!submitClickedRef.current && filtersSnapshotRef.current != null) {
            setSelectedFilterUniqueValueDict(filtersSnapshotRef.current);
        }
        submitClickedRef.current = false;
        setShowfilters(false);
    };
    const handle_filters_show = async () => {
        const lp = selected_filter_unique_value_dict["landing_page"];
        if (!lp || !Array.isArray(lp.filter_val) || lp.filter_val.length === 0) {
            toast.error('Please select a landing page first.');
            return;
        }
        // Snapshot current advanced filter state so we can restore on Cancel
        filtersSnapshotRef.current = JSON.parse(JSON.stringify(selected_filter_unique_value_dict));
        submitClickedRef.current = false;
        const selectedLandingPage = lp.filter_val[0] || null;
        try {
            await getFiltersData(Cookies.get('shop'), selectedLandingPage);
        } catch (err) {
            console.warn('Failed to load filter options for modal:', err);
        }
        setShowfilters(true);
    };
    
    const applyFilters = async () => {
        try {
            setLoading(true);
            setError(null);
            
            // Clear Redis cache first to ensure fresh data
            try {
                await axios.post(`${app_url}/api/analytics-dashboard/clear_cache`, {
                    shop_domain: Cookies.get('shop')
                }, {withCredentials: true});
                console.log('Cache cleared before applying filters');
            } catch (cacheError) {
                console.warn('Failed to clear cache:', cacheError);
                // Continue with data fetch even if cache clear fails
            }
            
            // Prepare filters object (include date range from Time Period)
            const filters = {
                device: selected_filter_unique_value_dict["device"]["filter_val"].join(","),
                sxi_content: selected_filter_unique_value_dict["sxi_content"]["filter_val"].join(","),
                utm_source: selected_filter_unique_value_dict["utm_source"]["filter_val"].join(","),
                utm_medium: selected_filter_unique_value_dict["utm_medium"]["filter_val"].join(","),
                utm_campaign: selected_filter_unique_value_dict["utm_campaign"]["filter_val"].join(","),
                utm_content: selected_filter_unique_value_dict["utm_content"]["filter_val"].join(","),
                utm_term: selected_filter_unique_value_dict["utm_term"]["filter_val"].join(","),
                conversion: selected_filter_unique_value_dict["conversion"]["filter_val"].join(","),
                landing_page: selected_filter_unique_value_dict["landing_page"]["filter_val"].join(","),
                section_category: selected_filter_unique_value_dict["section_category"]["filter_val"].join(","),
                section_sub_category: selected_filter_unique_value_dict["section_sub_category"]["filter_val"].join(",")
            };
            if (selected_date_range_value && selected_date_range_value.length >= 2 && selected_date_range_value[0] && selected_date_range_value[1]) {
                filters.date_start = formatDate(selected_date_range_value[0]);
                filters.date_end = formatDate(selected_date_range_value[1]);
            }
            
            // Fetch section analytics data with filters
            const response = await axios.post(`${app_url}/api/analytics-dashboard/get_section_analytics`, {
                shop_domain: Cookies.get('shop'),
                filters: filters
            }, {withCredentials: true});
            
            if (response.data.success) {
                setAnalyticsData(response.data.data);
                
                // Don't overwrite filter options in applyFilters - they should come from getFiltersData
                console.log('ApplyFilters - Keeping existing filter options, not overwriting');
                setFilteredData(response.data.data);
                
                if (response.data.data.length === 0) {
                    setError('No analytics data found for the selected filters. Please try adjusting your filters.');
                }
            } else {
                setError('Failed to fetch analytics data');
                toast.error('Failed to fetch analytics data');
            }
        } catch (error) {
            console.error('Error applying filters:', error);
            setError('Error applying filters');
            toast.error('Error applying filters');
        } finally {
            setLoading(false);
        }
    };
    const handle_filters_submit = (e) => {
        e.preventDefault();
        submitClickedRef.current = true;
        handle_filters_hide();
        applyFilters();
    };

    const ADVANCED_FILTER_KEYS = ["device","sxi_content","utm_source","utm_medium","utm_campaign","utm_content","utm_term","conversion","section_category","section_sub_category"];
    const { appliedAdvancedFilters, hasAdvancedFiltersApplied, advancedFiltersCount } = useMemo(() => {
        const applied = ADVANCED_FILTER_KEYS
            .map(k => ({ key: k, label: k.replace(/_/g, ' '), vals: selected_filter_unique_value_dict[k]?.filter_val || [] }))
            .filter(({ vals }) => vals.length > 0);
        const count = applied.reduce((n, { vals }) => n + vals.length, 0);
        return {
            appliedAdvancedFilters: applied,
            hasAdvancedFiltersApplied: applied.length > 0,
            advancedFiltersCount: count
        };
    }, [selected_filter_unique_value_dict]);

    const generateSectionCards = () => {
        // The new API already returns formatted section cards
        // Just return the filtered data as it's already in the correct format
        return filteredData.map(section => ({
            section_id: section.section_id,
            section_name: section.section_name,
            section_image: section.section_image,
            landing_url: section.landing_url,
            avg_time_spent: section.avg_time_spent,
            total_views: section.total_views,
            total_time_spent: section.total_time_spent,
            weighted_avg_time_spent: section.weighted_avg_time_spent
        }));
    };

    const sectionCards = generateSectionCards();

    if (error) {
        return (
            <div className="main-container">
                <Card>
                    <Card.Body className="text-center">
                        <h5 className="text-danger">Error Loading Analytics</h5>
                        <p className="text-muted">{error}</p>
                        <Button 
                            variant="primary" 
                            onClick={() => {
                                setError(null);
                                fetchAnalyticsData();
                                getFiltersData(Cookies.get('shop'));
                            }}
                        >
                            Try Again
                        </Button>
                    </Card.Body>
                </Card>
            </div>
        );
    }

    return (
        <div className='main-container'>
            {!shop_domain?
                <div className='go_to_shopify_admin_div'>
                    <h6 style={{display:'inline-block'}}>!! Go to Shopify Admin and open our app !!</h6>
                </div>
                :
                <>
                    <Modal show={show_filters} onHide={handle_filters_hide}>
                        <Modal.Header closeButton>
                        <Modal.Title>Filters</Modal.Title>
                        </Modal.Header>
                        <Modal.Body style={{height:"60vh", overflowY:"scroll"}}>
                            
                            {["device","sxi_content","utm_source","utm_medium","utm_campaign","utm_content","utm_term","conversion","section_category","section_sub_category"].map((val1) => {
                                return (                            
                                    <Container key={val1}>
                                        <Row className='my-3'>
                                            <p className='charts_popup_filter_heading'>{val1.replace('_', ' ').toUpperCase()}</p>
                                        </Row>
                                        <Row>
                                            <ReMultiSelect
                                                key={`${val1}-${(filter_unique_value_dict[val1] || []).length}`}
                                                className='popup_filter_options'
                                                id={`${val1}_options`}
                                                closeMenuOnSelect={false}
                                                components={{
                                                    ...ReMultiSelectAnimated(),
                                                    Option: CheckboxOption
                                                }}
                                                value={selected_filter_unique_value_dict[val1]["filter_val"].map(v => ({
                                                    value: v,
                                                    label: v
                                                }))}
                                                isMulti={true}
                                                options={filter_unique_value_dict[val1] || []}
                                                menuPortalTarget={document.body}
                                                menuPosition="fixed"
                                                styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                                                onChange={(selected_vals) => {
                                                    let temp_filter_dict = { ...selected_filter_unique_value_dict };
                                                    const valuesArray = Array.isArray(selected_vals)
                                                        ? selected_vals.map(opt => opt.value)
                                                        : [];
                                                    temp_filter_dict[val1]["filter_val"] = valuesArray;
                                                    setSelectedFilterUniqueValueDict(temp_filter_dict);
                                                }}
                                                placeholder={`Select ${val1.replace('_', ' ')}...`}
                                            />
                                        </Row>
                                    </Container>
                                );
                            })}

                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="primary" onClick={handle_filters_submit}>Submit</Button>
                            <Button variant="secondary" onClick={handle_filters_hide}>Close</Button>
                        </Modal.Footer>
                    </Modal>
                    
                        <>
                            <div className='main-title mt-4'>
                                <h2>Analytics Dashboard</h2>
                            </div>

                            <Container className='mt-3 mb-2'>
                                <Row className='justify-content-md-left' lg={3} xs={1}>
                                    <Col className='p-2'>
                                        <Label className="charts_filter_label">Time Period</Label>
                                        <br />
                                        <DateRangePicker
                                            shouldDisableDate={combine(before(max_date), afterToday())}
                                            editable={false}
                                            value={selected_date_range_value}
                                            id='date_range'
                                            format="yyyy-MM-dd"
                                            character=" - "
                                            showOneCalendar
                                            block
                                            onChange={handleDateChange}
                                        />
                                        
                                    </Col>
                                    <Col className='p-2'>
                                        <Label className="charts_filter_label">Landing Page</Label>
                                        <br />
                                        <ReMultiSelect
                                            className='landing-page-filter'
                                            id='landing_page_filter'
                                            closeMenuOnSelect={true}
                                            components={ReMultiSelectAnimated()}
                                            value={selected_filter_unique_value_dict["landing_page"]["filter_val"].length > 0 ? 
                                                [{"value": selected_filter_unique_value_dict["landing_page"]["filter_val"][0], "label": selected_filter_unique_value_dict["landing_page"]["filter_val"][0]}] : 
                                                []
                                            }
                                            isMulti={false}
                                            options={(() => {
                                                console.log('Current filter_unique_value_dict["landing_page"]:', filter_unique_value_dict["landing_page"]);
                                                const options = filter_unique_value_dict["landing_page"] || [];
                                                // Ensure options are in the correct format for ReMultiSelect
                                                if (options.length > 0 && typeof options[0] === 'string') {
                                                    return options.map(url => ({value: url, label: url}));
                                                }
                                                return options;
                                            })()}
                                            onChange={(selected_val) => {
                                                // Only update landing_page selection; keep any existing advanced filters
                                                setSelectedFilterUniqueValueDict(prev => {
                                                    const next = { ...prev };
                                                    if (!next["landing_page"]) {
                                                        next["landing_page"] = { filter_val: [] };
                                                    }
                                                    if (selected_val && selected_val.value) {
                                                        next["landing_page"].filter_val = [selected_val.value];
                                                    } else {
                                                        next["landing_page"].filter_val = [];
                                                    }
                                                    return next;
                                                });
                                            }}
                                            menuPortalTarget={document.body}
                                            menuPosition="fixed"
                                            styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                                            placeholder="Select Landing Page..."
                                        />
                                    </Col>
                                    <Col className='p-2 d-flex align-items-end'>
                                        <Button className='analytics-filter-btn' onClick={() => applyFilters()}>
                                        Apply
                                        </Button>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col className='p-2 d-flex align-items-end flex-wrap'>
                                        <Button
                                            className={`analytics-filter-btn ${hasAdvancedFiltersApplied ? 'analytics-filter-btn-active' : ''}`}
                                            onClick={handle_filters_show}
                                        >
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-filter-left" viewBox="0 0 16 16">
                                                <path d="M2 10.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m0-3a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5m0-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5"/>
                                            </svg>
                                            Advance Filters
                                            {advancedFiltersCount > 0 && (
                                                <Badge className="ms-2 analytics-advance-filter-badge" bg="light" text="dark">{advancedFiltersCount}</Badge>
                                            )}
                                        </Button>
                                        {appliedAdvancedFilters.length > 0 && (
                                            <div className="d-flex flex-wrap align-items-center gap-1 ms-2 mt-1 mt-md-0">
                                                <small className="text-muted me-1">Applied:</small>
                                                {appliedAdvancedFilters.map(({ key, label, vals }) => (
                                                    <Badge key={key} className="analytics-badge analytics-applied-filter-badge" bg="secondary" text="light" title={vals.join(', ')}>
                                                        {label}: {vals.length > 2 ? `${vals[0]}, ${vals[1]} +${vals.length - 2}` : vals.join(', ')}
                                                    </Badge>
                                                ))}
                                            </div>
                                        )}
                                    </Col>
                                </Row>
                            </Container>

                            <Container className='p-2 mt-3'>
                                { !loading ?
                                <>
                                <Row className="g-4">
                                    {sectionCards.map((section, index) => (
                                        <Col key={`${section.section_id}_${index}`} xs={12} md={12} lg={12}>
                                            <Card className="h-100 analytics-card">
                                                <Card.Body>
                                                    <Row>
                                                        <Col xs={8}>
                                                            <div className="analytics-card-image">
                                                                {section.section_image ? (
                                                                    <a href={section.section_image} target="_blank">
                                                                        <img 
                                                                        src={section.section_image} 
                                                                        alt={section.section_name}
                                                                        className="img-fluid"
                                                                        style={{width: '100%', height: '100%', objectFit: 'cover'}}
                                                                        />
                                                                    </a>
                                                                ) : (
                                                                    <div className="analytics-placeholder-image">
                                                                        <i className="fas fa-chart-bar"></i>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </Col>
                                                        <Col xs={4}>
                                                            <div className="analytics-card-content">
                                                                <div className="analytics-metrics">
                                                                    <div className="metric-row">
                                                                        {/* <div className="metric-item">
                                                                            <small className="text-muted">Section ID</small>
                                                                            <div className="metric-value"> {section.section_id}</div>
                                                                        </div> */}
                                                                        <div className="metric-item">
                                                                            <small className="text-muted">Section Name</small>
                                                                            <div className="metric-value"> {section.section_name}</div>
                                                                        </div>
                        
                                                                    </div>
                                                                    <div className="metric-row mt-3">
                                                                          <div className="metric-item">
                                                                              <small className="text-muted">Avg. Time Spent</small>
                                                                              <div className="metric-value"> {section.avg_time_spent} sec</div>
                                                                          </div>
                                                                          <div className="metric-item">
                                                                              <small className="text-muted">Cog Score</small>
                                                                              <div className="metric-value"> {section.weighted_avg_time_spent}</div>
                                                                          </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </Card.Body>
                                            </Card>
                                        </Col>
                                    ))}
                                </Row>

                                {sectionCards.length === 0 && (
                                    <Card>
                                        <Card.Body className="text-center">
                                            <h5>No Analytics Data Found</h5>
                                            <p className="text-muted">Try adjusting your filters to see analytics data.</p>
                                        </Card.Body>
                                    </Card>
                                )}
                                </>: 
                                <div className='main_conatiner_spinner'>
                                    <Spinner animation="border"/>
                                </div>
                            }
                            </Container>
                        </>
                        
                        
                    
                </>
            }
        </div>
    );
}

export default AnalyticsDashboard

function formatDate(date, is_increase_date=false) {
    var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + (is_increase_date? d.getDate() + 1: d.getDate()),
      year = d.getFullYear();
  
    if (month.length < 2)
      month = '0' + month;
    if (day.length < 2)
      day = '0' + day;
  
    return [year, month, day].join('-');
}

function get_filter_unique_value(analytics_data){    
    var temp_filter_data = {};
    // landing_page options come from MongoDB, not from analytics data
    temp_filter_data["landing_page"] = []; // Will be populated from MongoDB
    temp_filter_data["sxi_content"] = ConvertArrayToFilterLabel(Array.from(new Set(analytics_data.map(item => item.sxi_content).filter(Boolean))));
    temp_filter_data["sxi_id"] = ConvertArrayToFilterLabel(Array.from(new Set(analytics_data.map(item => item.sxi_id).filter(Boolean))));
    temp_filter_data["sxi_location_id"] = ConvertArrayToFilterLabel(Array.from(new Set(analytics_data.map(item => item.sxi_location_id).filter(Boolean))));
    temp_filter_data["device"] = ConvertArrayToFilterLabel(Array.from(new Set(analytics_data.map(item => item.device).filter(Boolean))));
    temp_filter_data["httpReferrer"] = ConvertArrayToFilterLabel(Array.from(new Set(analytics_data.map(item => item.httpReferrer).filter(Boolean))));

    return temp_filter_data;
}

function ConvertArrayToFilterLabel(arr){
    var temp_arr = [];
    if(arr){
        for(var x of arr){
            if(x !== ""){
                temp_arr.push({"value":x,"label":x})
            }
        }
    }
    return temp_arr;
}

function apply_filter_on_data(data, selected_filter){
    let filtered_data = data;
    for(let key of Object.keys(selected_filter)){
        if(selected_filter[key]["filter_val"].length > 0){
            if(selected_filter[key]["order_no"] === "any"){
                filtered_data = filtered_data.filter(item => {
                    const value = item[key];
                    return selected_filter[key]["operator"] === "IN" 
                        ? selected_filter[key]["filter_val"].includes(value)
                        : !selected_filter[key]["filter_val"].includes(value);
                });
            }
            if(selected_filter[key]["order_no"] === "first"){
                // For analytics data, we'll treat this as any since there's no order concept
                filtered_data = filtered_data.filter(item => {
                    const value = item[key];
                    return selected_filter[key]["operator"] === "IN" 
                        ? selected_filter[key]["filter_val"].includes(value)
                        : !selected_filter[key]["filter_val"].includes(value);
                });
            }
            if(selected_filter[key]["order_no"] === "all"){
                // For analytics data, we'll treat this as any since there's no order concept
                filtered_data = filtered_data.filter(item => {
                    const value = item[key];
                    return selected_filter[key]["operator"] === "IN" 
                        ? selected_filter[key]["filter_val"].includes(value)
                        : !selected_filter[key]["filter_val"].includes(value);
                });
            }
        }
    }
    return filtered_data;
}
